import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Routers
import pagesRouter from "./pageRouter";
import surveysRouter from "./surveyRouter";
import emulationsRouter from "./emulationRouter";
import timekeepingsRouter from "./timekeepingRouter";
import briefingsRouter from "./briefingsRouter";
import revenuesRouter from "./revenueRouter";
import usersRouter from "./userRouter";
import calendarRouter from "./calendarRouter";
import budgetReportRouter from "./budgetReportRouter";
import publicBudgetReportRouter from "./publicBudgetReportRouter";
import departmentRouter from "./departmentRouter";
import licenseRouter from "./licenseRouter";
import briefingsCollectionRPRouter from "./briefingsCollectionRPRouter";
import databasefinanceRouter from "./databasefinanceRouter";

Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Trang chủ",
          component: () => import("@/views/screens/Dashboard"),
          meta: {
            requiresAuth: false,
          },
        },
        ...usersRouter,
        ...briefingsRouter,
        ...revenuesRouter,
        ...timekeepingsRouter,
        ...emulationsRouter,
        ...surveysRouter,
        ...calendarRouter,
        ...budgetReportRouter,
        ...departmentRouter,
        ...briefingsCollectionRPRouter,
        ...databasefinanceRouter,
      ],
    },
    ...pagesRouter,
    ...publicBudgetReportRouter,
    ...licenseRouter,
  ];
}
const DEFAULT_TITLE = "Hệ thống quản lý nội bộ Sở Tài Chính Thái Nguyên";
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("accessToken") == null) {
      next({
        path: "/pages/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  }
  Vue.nextTick(() => {
    document.title = to.meta.title
      ? `${to.meta.title} | Sở Tài chính Thái Nguyên`
      : DEFAULT_TITLE;
  });
  next();
});

router.afterEach(() => {
  const tooltip = document.querySelector(".vs-tooltip");
  if (tooltip !== null) document.body.removeChild(tooltip);
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
